import { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import MDTypography from "../MDTypography";
import colors from "../../assets/theme/base/colors";
import { useSelector } from "react-redux";
import MDBox from "../MDBox";

/**
 *
 * @param {variation} has name tags ontop SubMenu
 * @param {MenuSubtitle1} Variation = "personal" display tag at start of Dropdown
 * @param {MenuSubtitle2}  Variation = "personal" display tag at start of Dropdown below MenuSubtitle1
 * @returns
 */
const CustomMenuItem = (props) => {
  const {
    MenuTitle,
    MenuSubtitle1,
    MenuSubtitle2,
    MenuTo,
    MenuAppClaims,
    isOpenNewTab,
    SubMenu,
    usePopper,
    variation,
  } = props;

  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [filteredSubMenu, setFilteredSubMenu] = useState(null);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    setOpen(false);
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleNavigate = (event, to, isOpenNewTab) => {
    // Use Navigate or Window HREF Logic
    /* #region  Navigation : To. */

    if (to !== undefined) {
      var useWindowNav = false;
      useWindowNav = to.includes("https://") ? true : useWindowNav;
      useWindowNav = to.includes("http://") ? true : useWindowNav;
      useWindowNav = to.includes("localhost:") ? true : useWindowNav;

      if (useWindowNav) {
        if (isOpenNewTab) window.open(to);
        else window.location.replace(to);
      } else {
        navigate(to);
      }
      /* #endregion */

      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
    }
  };

  useEffect(() => {
    var tmpSubMenuList = getFilteredSubMenu();
    setFilteredSubMenu(tmpSubMenuList);
  }, []);

  /** Check against user claims and return sub menu LIST */
  function getFilteredSubMenu() {
    var tmpSubMenuList = [];
    if (SubMenu !== undefined && SubMenu !== null) {
      SubMenu.forEach((element) => {
        if (hasValidClaim(element.appRequiredClaim)) {
          tmpSubMenuList.push(element);
        }
      });
    }

    return tmpSubMenuList;
  }
  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }
  const hasValidClaim = (requiredClaims) => {
    var valid = false;
    if ((requiredClaims?.length ?? 0) === 0) valid = true;
    else {
      var requiredCl = requiredClaims[0];
      var tmpClaimVal = requiredCl.split(".");
      var filteredUserClaims = undefined;

       // * = Indicates any permission claim for app
       if (tmpClaimVal[1] === "*") {
        filteredUserClaims = user.roleClaims.find((userClaim) =>
          userClaim.toLowerCase().includes((tmpClaimVal[0] + ".").toLowerCase())
        );
      }
      // Specific permission claim for app
      else {
        filteredUserClaims = user.roleClaims.find((userClaim) =>
          userClaim.toLowerCase().includes(requiredCl.toLowerCase())
        );
      }

      if (filteredUserClaims !== undefined) valid = true;
    }
    return valid;
  };
  const SubMenuList = () => {
    return (
      <MenuList
        key={"SubMenuListxMuiNavbar" + user.token}
        autoFocusItem={open}
        id="composition-menu"
        aria-labelledby="composition-button"
        onKeyDown={handleListKeyDown}
      >
        {filteredSubMenu.map((page) => (
          <MenuItem
            disabled={page.disabled === true}
            key={page.title}
            onClick={(e) => {
              if (page.menuFunction !== undefined) {
                page.menuFunction();
              } else {
                handleNavigate(e, page.to, page.isOpenNewTab || false);
              }

              setOpen(false);
            }}
          >
            {page.icon}
            <MDTypography
              variant="h6"
              sx={{
                paddingLeft: "0.3rem",
                fontWeight: "500",
                fontSize: 17,
              }}
            >
              {page.title}
            </MDTypography>
          </MenuItem>
        ))}
      </MenuList>
    );
  };
  const MenuTitleElement = () => {
    return (
      <MDTypography
        color="dark"
        variant="h6"
        sx={{
          fontWeight: "600",
          fontSize: 17.5,
          "&:hover": {
            color: colors.JTCElectricBlue,
          },
        }}
      >
        {MenuTitle}
      </MDTypography>
    );
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      {((filteredSubMenu?.length ?? 0) > 0 || MenuTo !== "") &&
        hasValidClaim(MenuAppClaims) && (
          <MDBox     sx={{
            height:"100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <Button
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? "composition-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={(e) =>
                filteredSubMenu === null || filteredSubMenu.length === 0
                  ? handleNavigate(e, MenuTo, isOpenNewTab)
                  : handleToggle(e)
              }
              endIcon={
                filteredSubMenu !== null &&
                filteredSubMenu.length > 0 &&
                (open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)
              }
              sx={{
                ml: "0rem",
                overflow: "auto",
                // whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                textAlign: "left", 
              }}
            >
              {MenuTitleElement()}
            </Button>
            {filteredSubMenu !== null && filteredSubMenu.length > 0 && (
              <>
                {usePopper && (
                  <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                    style={{
                      paddingLeft: "1.2em", // Adding padding left of
                    }}
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom-start"
                              ? "left top"
                              : "left bottom",
                        }}
                      >
                        <Paper>
                          <ClickAwayListener onClickAway={handleClose}>
                            <div>
                              {variation === "personal" && (
                                <MDBox px={2} pt={2} mb={-0.5}>
                                  <MDTypography
                                    fontSize={"1rem"}
                                    fontWeight={"bold"}
                                  >
                                    {MenuSubtitle1 || ""}
                                  </MDTypography>
                                  <MDTypography fontSize={"0.85rem"}>
                                    {MenuSubtitle2 || ""}
                                  </MDTypography>
                                  <Divider />
                                </MDBox>
                              )}
                              {open && SubMenuList()}
                            </div>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                )}
                {open && !usePopper && (
                  <ClickAwayListener onClickAway={handleClose}>
                    <Box pl={"1rem"}>{SubMenuList()}</Box>
                  </ClickAwayListener>
                )}
              </>
            )}
          </MDBox>
        )}
    </div>
  );
};

CustomMenuItem.defaulProps = {
  usePopper: true,
};

export default CustomMenuItem;
